import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterSidebar = ({ filters, onFilterChange, onClearFilters }) => {
  const licenseStatusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'valid', label: 'Valid' },
    { value: 'expiring', label: 'Expiring Soon' },
    { value: 'expired', label: 'Expired' },
    { value: 'suspended', label: 'Suspended' }
  ];

  const assignmentTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'primary', label: 'Primary Driver' },
    { value: 'relief', label: 'Relief Driver' },
    { value: 'unassigned', label: 'Unassigned' }
  ];

  const yardLocationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'yard-001', label: 'Phoenix Main Yard' },
    { value: 'yard-002', label: 'Tucson Distribution' },
    { value: 'yard-003', label: 'Flagstaff Terminal' },
    { value: 'yard-004', label: 'Mesa Service Center' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1 h-full overflow-y-auto">
      <div className="sticky top-0 bg-card border-b border-border px-4 py-3 z-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="Filter" size={20} color="var(--color-primary)" strokeWidth={2} />
            <h3 className="text-sm font-semibold text-foreground">Filters</h3>
          </div>
          <button
            onClick={onClearFilters}
            className="text-xs text-primary hover:text-primary/80 font-medium transition-hover"
          >
            Clear All
          </button>
        </div>
      </div>
      <div className="p-4 space-y-6">
        <div>
          <Input
            type="search"
            label="Search Drivers"
            placeholder="Name, ID, or phone..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="mb-0"
          />
        </div>

        <div>
          <Select
            label="License Status"
            options={licenseStatusOptions}
            value={filters?.licenseStatus}
            onChange={(value) => onFilterChange('licenseStatus', value)}
          />
        </div>

        <div>
          <Select
            label="Assignment Type"
            options={assignmentTypeOptions}
            value={filters?.assignmentType}
            onChange={(value) => onFilterChange('assignmentType', value)}
          />
        </div>

        <div>
          <Select
            label="Yard Location"
            options={yardLocationOptions}
            value={filters?.yardLocation}
            onChange={(value) => onFilterChange('yardLocation', value)}
          />
        </div>

        <div className="border-t border-border pt-4">
          <label className="text-sm font-medium text-foreground mb-3 block">Status</label>
          <div className="space-y-2">
            <Checkbox
              label="Active Drivers"
              checked={filters?.showActive}
              onChange={(e) => onFilterChange('showActive', e?.target?.checked)}
            />
            <Checkbox
              label="Inactive Drivers"
              checked={filters?.showInactive}
              onChange={(e) => onFilterChange('showInactive', e?.target?.checked)}
            />
          </div>
        </div>

        <div className="border-t border-border pt-4">
          <label className="text-sm font-medium text-foreground mb-3 block">Compliance</label>
          <div className="space-y-2">
            <Checkbox
              label="License Expiring (30 days)"
              checked={filters?.licenseExpiring}
              onChange={(e) => onFilterChange('licenseExpiring', e?.target?.checked)}
            />
            <Checkbox
              label="Missing Documents"
              checked={filters?.missingDocs}
              onChange={(e) => onFilterChange('missingDocs', e?.target?.checked)}
            />
          </div>
        </div>

        <div className="bg-muted/50 rounded-md p-3">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={16} color="var(--color-muted-foreground)" strokeWidth={2} className="mt-0.5" />
            <p className="text-xs text-muted-foreground">
              Use filters to quickly find drivers by status, assignment, or location. All changes are applied in real-time.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;